import type { ReactNode } from 'react';
import Overline from '@/components/ui/Overline/Overline';
import styles from './SectionHeader.module.css';

// セクション見出しパターン（DESIGN §11.12）：
// [欧文オーバーライン（+任意の連番）] → [和文 H2] → [リード文（任意）]。
type Props = {
  /** 欧文オーバーライン（道標）。例: WHY / WHAT YOU CAN READ。 */
  overline?: string;
  /** 任意の連番。01 形式（DIN narrow・タブラー）で表示。 */
  index?: number;
  title: ReactNode;
  lead?: ReactNode;
  theme?: 'light' | 'dark';
  align?: 'start' | 'center';
  /** h2 に付与する id（アンカー/aria 用）。 */
  titleId?: string;
  className?: string;
};

export default function SectionHeader({
  overline,
  index,
  title,
  lead,
  theme = 'light',
  align = 'start',
  titleId,
  className,
}: Props) {
  const rootCls = [
    styles.root,
    theme === 'dark' && styles.dark,
    align === 'center' && styles.center,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootCls}>
      {(overline || index != null) && (
        <p className={styles.eyebrow}>
          {index != null && (
            <span className={styles.index}>{String(index).padStart(2, '0')}</span>
          )}
          {overline && <Overline className={styles.overline}>{overline}</Overline>}
        </p>
      )}
      <h2 id={titleId} className={styles.title}>
        {title}
      </h2>
      {lead && <p className={styles.lead}>{lead}</p>}
    </div>
  );
}
